const pageNameKey = "editGatewayName";

export const editGatewayNameEn = {
  [pageNameKey]: {
    save: "Save",
    edit: "Edit",
    cancel: "Cancel",
    errorInputEmpty: "Input cannot be empty",
    errorUpdateFailed:
      "It was not possible to modify the name, therefore we reverted the changes.",
    successfullyUpdated: "Gateway name was successfully updated.",
  },
};

export const editGatewayNamePtBr = {
  [pageNameKey]: {
    save: "Salvar",
    edit: "Editar",
    cancel: "Cancelar",
    errorInputEmpty: "A entrada não pode estar vazia",
    errorUpdateFailed:
      "Não foi possível modificar o nome, portanto revertimos as alterações.",
    successfullyUpdated: "O nome do gateway foi atualizado com sucesso.",
  },
};

export const editGatewayNameDe = {
  [pageNameKey]: {
    save: "Speichern",
    edit: "Bearbeiten",
    cancel: "Abbrechen",
    errorInputEmpty: "Eingabe darf nicht leer sein",
    errorUpdateFailed:
      "Es war nicht möglich, den Namen zu ändern, daher haben wir die Änderungen rückgängig gemacht.",
    successfullyUpdated: "Gateway-Name erfolgreich aktualisiert.",
  },
};

export const editGatewayNameZhHans = {
  [pageNameKey]: {
    save: "保存",
    edit: "编辑",
    cancel: "取消",
    errorInputEmpty: "输入不能为空",
    errorUpdateFailed: "无法修改名称，因此我们已撤销更改。",
    successfullyUpdated: "网关名称已成功更新。",
  },
};

export const editGatewayNameIt = {
  [pageNameKey]: {
    save: "Salva",
    edit: "Modifica",
    cancel: "Annulla",
    errorInputEmpty: "Il campo non può essere vuoto",
    errorUpdateFailed:
      "Non è stato possibile modificare il nome, quindi abbiamo ripristinato le modifiche.",
    successfullyUpdated: "Nome gateway aggiornato con successo.",
  },
};

export const editGatewayNameEs = {
  [pageNameKey]: {
    save: "Guardar",
    edit: "Editar",
    cancel: "Cancelar",
    errorInputEmpty: "El campo no puede estar vacío",
    errorUpdateFailed:
      "No fue posible modificar el nombre, por lo tanto revertimos los cambios.",
    successfullyUpdated: "El nombre del gateway se actualizó correctamente.",
  },
};

export const editGatewayNameNl = {
  [pageNameKey]: {
    cancel: "Annuleren",
    edit: "Bewerken",
    errorInputEmpty: "Invoer mag niet leeg zijn",
    errorUpdateFailed:
      "Het was niet mogelijk om de naam te wijzigen, daarom hebben we de wijzigingen teruggedraaid.",
    save: "Opslaan",
    successfullyUpdated: "Gatewaynaam is succesvol bijgewerkt.",
  },
};

export const editGatewayNameTr = {
  [pageNameKey]: {
    cancel: "İptal etmek",
    edit: "Düzenlemek",
    errorInputEmpty: "Giriş boş olamaz",
    errorUpdateFailed:
      "Adı değiştirmek mümkün olmadığından değişiklikleri geri aldık.",
    save: "Kaydetmek",
    successfullyUpdated: "Ağ geçidi adı başarıyla güncellendi.",
  },
};
